import React, {
  FunctionComponent,
  useContext,
  useEffect,
  useState,
} from "react";
import { ChoiceList } from "@cmsgov/ds-medicare-gov";
import { useTranslate, sendTealiumEvent } from "../../../helpers";
import { CCXPMultiSelect } from "../../../components";
import { default as C, SearchFilterKeys } from "./constants";
import { AppContext } from "../../../app/store/AppStore";
import { PlanSNPType } from "../../../@types";
import { searchResultsFilterAnalytics } from "./helpers";
import { useFlags } from "launchdarkly-react-client-sdk";
import messages_en from "../../../translations/en-US.json";

interface Props {
  onFilterUpdate: (newValues: string[]) => void;
  basicMode?: boolean;
}

const SpecialNeedsPlansFilter: FunctionComponent<Props> = ({
  onFilterUpdate,
  basicMode,
}) => {
  const t = useTranslate();
  const flags = useFlags();
  const {
    state: { snpFilters },
    state,
  } = useContext(AppContext);
  const [currentSelections, setCurrentSelections] = useState(snpFilters || []);
  const choices = Object.keys(C.snpFilterTranslationMap).map(snpKey => ({
    checked: !!currentSelections.includes(snpKey as PlanSNPType),
    label: t(C.snpFilterTranslationMap[snpKey]),
    value: snpKey,
  }));

  useEffect(() => {
    setCurrentSelections(snpFilters || []);
  }, [snpFilters]);

  const label = t("search_results_page.add_special_needs_plans");

  return basicMode ? (
    <ChoiceList
      name="OpenPlanCoveragesFilter"
      type="checkbox"
      label={<p className="PlanFilters__action__label">{label}</p>}
      className="PlanFilters__filterGroupHeading"
      onChange={event => {
        const { checked, value } = event.currentTarget;
        const selected =
          checked && !currentSelections.includes(value)
            ? [...currentSelections, value]
            : currentSelections.filter(f => f !== value);
        setCurrentSelections(selected);
        onFilterUpdate(selected);
      }}
      choices={choices}
    />
  ) : (
    <div className="Filter">
      <CCXPMultiSelect
        label={label}
        size="widest"
        values={snpFilters as string[]}
        options={choices}
        onUpdate={(newFilterValues: string[]): void => {
          sendTealiumEvent(
            "Find Plans - Available Plans",
            "Plans for both Medicare and Medicaid"
          );
          newFilterValues.forEach(value => {
            const filterValue: string | undefined =
              messages_en[C.snpFilterTranslationMap[value]];
            if (filterValue) {
              searchResultsFilterAnalytics({
                state,
                flags,
                filterValue,
                filterType: SearchFilterKeys.specialNeedsFilter,
              });
            }
          });
          onFilterUpdate(newFilterValues);
        }}
      />
    </div>
  );
};

export default SpecialNeedsPlansFilter;
